import { CANDIDATE_USER_TYPE } from "@/enums/userTypes";

export function userIsCandidate(
  value?: number,
): value is typeof CANDIDATE_USER_TYPE.value {
  return value === CANDIDATE_USER_TYPE.value;
}
